export var DateFormatType;
(function (DateFormatType) {
    DateFormatType[DateFormatType["YYMMDD"] = 0] = "YYMMDD";
    DateFormatType[DateFormatType["MMDDYY"] = 1] = "MMDDYY";
    DateFormatType[DateFormatType["DDMMYY"] = 2] = "DDMMYY";
})(DateFormatType || (DateFormatType = {}));
